(() => {
  if (window.CandylandProductCardMobile) return;
  window.CandylandProductCardMobile = true;

  let activeCard = null;
  let activeTiltCard = null;

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getWrapper(card) {
    return card && card.querySelector('.product-card__image-wrapper');
  }

  function loadSecondImage(secondImage) {
    if (!secondImage || !secondImage.dataset.backgroundImage) return;

    secondImage.style.backgroundImage = `url("${secondImage.dataset.backgroundImage}")`;
    secondImage.removeAttribute('data-background-image');
  }

  function setupSecondImageLazyLoad(root = document) {
    const secondImages = Array.from(root.querySelectorAll('.product-card__image--second-mobile-fix[data-background-image]'));
    if (!secondImages.length) return;

    if (!('IntersectionObserver' in window)) {
      secondImages.forEach(loadSecondImage);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        loadSecondImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '700px 0px' });

    secondImages.forEach((image) => observer.observe(image));
  }

  function applyTilt(card, rotateX, rotateY) {
    const wrapper = getWrapper(card);
    if (!wrapper) return;

    wrapper.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.04)`;
  }

  function resetTilt(card) {
    const wrapper = getWrapper(card);
    if (wrapper) wrapper.style.transform = '';
    if (card) card.classList.remove('mobile-tilt-active');
  }

  function clearActiveCard() {
    if (activeCard) {
      activeCard.classList.remove('mobile-second-image');
      resetTilt(activeCard);
    }

    activeCard = null;
    activeTiltCard = null;
  }

  function requestMotionPermission() {
    if (
      typeof DeviceOrientationEvent !== 'undefined' &&
      typeof DeviceOrientationEvent.requestPermission === 'function'
    ) {
      DeviceOrientationEvent.requestPermission().catch(() => {});
    }
  }

  function handleDeviceTilt(event) {
    if (!activeTiltCard || !isMobile()) return;

    const beta = clamp(event.beta || 0, -25, 25);
    const gamma = clamp(event.gamma || 0, -25, 25);

    applyTilt(activeTiltCard, -beta / 3, gamma / 3);
  }

  window.addEventListener('deviceorientation', handleDeviceTilt, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupSecondImageLazyLoad(), { once: true });
  } else {
    setupSecondImageLazyLoad();
  }

  document.addEventListener('shopify:section:load', (event) => {
    setupSecondImageLazyLoad(event.target);
  });

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.product-card.has-second-image');

    if (!card) {
      if (!event.target.closest('.product-card')) clearActiveCard();
      return;
    }

    const link = event.target.closest('.product-card__image-link');
    if (!link || !card.contains(link) || !isMobile()) return;

    const wrapper = getWrapper(card);
    const secondImage = card.querySelector('.product-card__image--second-mobile-fix');
    if (!wrapper || !secondImage) return;

    loadSecondImage(secondImage);
    requestMotionPermission();

    if (!card.classList.contains('mobile-second-image')) {
      event.preventDefault();

      if (activeCard && activeCard !== card) {
        activeCard.classList.remove('mobile-second-image');
        resetTilt(activeCard);
      }

      card.classList.add('mobile-second-image');
      card.classList.add('mobile-tilt-active');

      activeCard = card;
      activeTiltCard = card;
    }
  });

  document.addEventListener('touchmove', (event) => {
    if (!isMobile()) return;

    const wrapper = event.target.closest('.product-card__image-wrapper');
    const card = wrapper && wrapper.closest('.product-card.has-second-image');
    if (!card || !card.classList.contains('mobile-second-image')) return;

    const touch = event.touches && event.touches[0];
    if (!touch) return;

    const rect = wrapper.getBoundingClientRect();
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top;

    const rotateY = clamp(((x / rect.width) - 0.5) * 18, -9, 9);
    const rotateX = clamp((0.5 - y / rect.height) * 18, -9, 9);

    activeTiltCard = card;
    card.classList.add('mobile-tilt-active');

    applyTilt(card, rotateX, rotateY);
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (!isMobile()) return;

    const wrapper = event.target.closest('.product-card__image-wrapper');
    const card = wrapper && wrapper.closest('.product-card.has-second-image');
    if (!card || !card.classList.contains('mobile-second-image')) return;

    setTimeout(() => {
      applyTilt(card, 0, 0);
    }, 80);
  });
})();
